import { tourKeys } from '../@utils/tourKeys'

const openAlertDrawer = () => {
    const addBtn = document.querySelector('.table-daily-buttons button')
    if (addBtn) addBtn.click()
}

const closeAlertDrawer = () => {
    const backdrop = document.querySelector('.rs-drawer-backdrop')
    if (backdrop) backdrop.click()
}

export default function getAlertsConfigSteps() {
    const k = tourKeys('alertsConfig')

    return [
        {
            target: '.sticky-header',
            contentKey: k.welcome,
            placement: 'bottom',
            disableBeacon: true,
            disableScrolling: true,
        },
        {
            target: '.table-alert-config',
            contentKey: k.table,
            placement: 'top',
            disableScrolling: true,
        },
        {
            target: '.title-tables',
            contentKey: k.alertTypes,
            placement: 'bottom',
            disableScrolling: true,
        },
        {
            target: '.table-daily-buttons',
            contentKey: k.addAlert,
            placement: 'left',
            data: {
                beforeNext: openAlertDrawer,
                delay: 1200,
            },
        },
        {
            target: '[data-tour="drawer-alert-form"]',
            contentKey: k.drawerOverview,
            placement: 'left',
            disableScrolling: true,
            data: {
                skipFilter: true,
                beforePrev: closeAlertDrawer,
                cleanup: closeAlertDrawer,
                delay: 600,
            },
        },
        {
            target: '[data-tour="drawer-alert-type"]',
            contentKey: k.drawerType,
            placement: 'bottom',
            disableScrolling: true,
            data: {
                skipFilter: true,
                cleanup: closeAlertDrawer,
            },
        },
        {
            target: '[data-tour="drawer-alert-basic"]',
            contentKey: k.drawerBasic,
            placement: 'left',
            disableScrolling: true,
            data: {
                skipFilter: true,
                cleanup: closeAlertDrawer,
            },
        },
        {
            target: '[data-tour="drawer-alert-hotel"]',
            contentKey: k.drawerHotel,
            placement: 'left',
            disableScrolling: true,
            data: {
                skipFilter: true,
                cleanup: closeAlertDrawer,
            },
        },
        {
            target: '[data-tour="drawer-alert-condition"]',
            contentKey: k.drawerCondition,
            placement: 'left',
            disableScrolling: true,
            data: {
                skipFilter: true,
                cleanup: closeAlertDrawer,
            },
        },
        {
            target: '[data-tour="drawer-alert-save"]',
            contentKey: k.drawerSave,
            placement: 'top',
            disableScrolling: true,
            data: {
                skipFilter: true,
                cleanup: closeAlertDrawer,
            },
        },
    ]
}
